import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from './baseQuery';
import { IPagedResult } from '../../shared/models/paged-result';
import { IFinancialAgreement } from '../../shared/models/sale/financial-agreement.model';
import { FinancialAgreementFilterSet } from '../../shared/models/sale/financial-agreement-filter-set';
import { serialize } from '../../utility/serialize';

export const financialAgreementApi = createApi({
  reducerPath: 'financialAgreementApi',
  baseQuery,
  tagTypes: ['FinancialAgreements'],
  endpoints: (builder) => ({
    getFinancialAgreements: builder.query<
      IPagedResult<IFinancialAgreement>,
      FinancialAgreementFilterSet
    >({
      query: (filterSet) => ({
        url: `/api/financialagreements?${serialize(filterSet)}`,
        method: 'GET',
      }),
    }),
  }),
});

export const { useGetFinancialAgreementsQuery, useLazyGetFinancialAgreementsQuery } =
  financialAgreementApi;
